import { Injectable } from '@angular/core';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private snackBars: SnackbarComponent[] = [];

  position!: number;

  constructor() {}

  add(modal: any) {
    this.snackBars.push(modal);
  }

  show(message: string, type: string = 'info', time: string = 'long') {
    const snackBar = this.snackBars[0];
    snackBar.show(message, type, time);
  }

  setPosition(position: number) {
    this.position = position;
  }

  getPosition() {
    return this.position;
  }
}
